/**
 * RESPONSIBILITY: one age band of the children's ministry.
 *
 * Rows rather than four fixed cards: the requirements doc's grade bands will move, and
 * when they do it should be an edit rather than a deploy.
 */
import { Row, Text, Paragraph } from '@framework/core/decorators';

@Row()
export class AgeGroup {
  @Text({ label: 'Title', maxLength: 120, description: 'e.g. Little Lambs.' })
  name!: string;

  @Text({ label: 'Ages', maxLength: 120, description: 'e.g. 3–5, or Kindergarten–2nd grade.' })
  ages!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 3, description: 'What happens in this group.' })
  description!: string;

  @Text({ label: 'Room', maxLength: 120, description: 'Where it meets.' })
  room!: string;
}
